import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@components/icon/icon.module';

import { InlineNotificationComponent } from './inline-notification/inline-notification.component';

@NgModule({
  declarations: [InlineNotificationComponent],
  exports: [InlineNotificationComponent],
  imports: [CommonModule, IconModule],
})
export class InlineNotificationModule {}
